import t from '@guestyci/localize/t.macro';

// TODO: legacy login pages have hardcoded strings, after they are deprecated change the values to camelCase
export const LoginPageModes = {
  REGISTER: 'REGISTER',
  LOGIN: 'LOGIN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  CHECK_EMAIL: 'CHECK_EMAIL',
  NEW_PASSWORD: 'NEW_PASSWORD',
  PASSWORD_CHANGED: 'PASSWORD_CHANGED', // TODO: is this used?
};

export const getPageTitle = (loginPageMode) => {
  switch (loginPageMode) {
    case LoginPageModes.REGISTER:
      return t('Register');
    case LoginPageModes.FORGOT_PASSWORD:
      return t('Forgot Password');
    case LoginPageModes.CHECK_EMAIL:
      return t('Check Email');
    case LoginPageModes.NEW_PASSWORD:
      return t('New Password');
    case LoginPageModes.LOGIN:
    default:
      return t('Login');
  }
};
